import { t } from "i18next";
import type { NavigateFunction } from "react-router-dom";
import { Eye } from "lucide-react";

import { RowActionsMenu } from "@/core/components/shared/data-table";
import type { TransactionDisputeRow } from "@/features/wallet/components/disputes/disputes-columns";

/**
 * Menu d'actions de ligne d'une contestation : voir le détail. Aucune
 * mutation au simple clic (règle projet) — rejet et restitution des fonds
 * vivent sur la page de détail, chacun derrière une preview de confirmation.
 */
export function DisputeRowActions({
  dispute,
  navigate,
}: {
  dispute: TransactionDisputeRow;
  /** Fourni par la fabrique de colonnes de `DataTableClar`. */
  navigate: NavigateFunction;
}) {
  return (
    <RowActionsMenu
      actions={[
        {
          id: "view",
          label: t("wallet.disputes.actions.view"),
          icon: Eye,
          onClick: () => navigate(`/app/wallet/disputes/${dispute.id}`),
        },
      ]}
    />
  );
}
